module.exports = __webpack_public_path__ + "img/gaming_book.4133b369.svg";